export default "__VITE_ASSET__Cq28BoZc__"